import Head from 'next/head'
import { useSelector } from 'react-redux'

import { configSelector } from 'src/state/selectors/globalDataSelectors'

interface LayoutHeadProps {
  title: string
  description?: string
}

export const LayoutHead: React.FC<LayoutHeadProps> = ({
  title,
  description,
}) => {
  const { company_name } = useSelector(configSelector)

  return (
    <Head>
      <title>
        {company_name}: {title}
      </title>

      {description && <meta name="Description" content={description} />}
    </Head>
  )
}
